module.exports = __webpack_public_path__ + "img/magazine-cover-two.7b8bb620.jpg";